module.exports = __webpack_public_path__ + "img/logoCard.e9042bf0.png";